import i18n from 'src/i18n'
import { useUserProfile } from 'src/context/userProfileContext'
import { Text } from './postsEmptyState.styles'

const PostsEmptyState = () => {
  const { isSessionUserProfile } = useUserProfile()

  return (
    <div className="_text-center _px-5 _py-6">
      <h3 className="_text-2 _text-gray-900 _font-weight-bold _mb-1">
        {i18n.t('profile.activities.posts.error_state.title')}
      </h3>

      <Text className="_text-1 _text-gray-600 _mb-0">
        {isSessionUserProfile
          ? i18n.t('profile.activities.posts.error_state.description.user')
          : i18n.t('profile.activities.posts.error_state.description.third_parties')}
      </Text>
    </div>
  )
}

export default PostsEmptyState
